'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$() {
}
export { $c_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$ as $c_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$ };
$p = $c_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$;
/** @constructor */
function $h_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$() {
}
export { $h_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$ as $h_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$ };
$h_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$.prototype = $p;
var $d_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$, "com.raquo.laminar.modifiers.RenderableSeq$collectionSeqRenderable$", ({
  iD: 1,
  iC: 1
}));
export { $d_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$ as $d_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$ };
var $n_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$;
function $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$() {
  if ((!$n_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$)) {
    $n_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$ = new $c_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$();
  }
  return $n_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$;
}
export { $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$ as $m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$ };
